/*
tslint:disable:import-spacing no-inferrable-types
variable-name align no-trailing-whitespace component-class-suffix
no-string-literal component-selector
*/

import 'ag-grid-enterprise';
import {WorkBlock}                 from '@/models/scenario/work.block';
import {ICellRenderer, ICellRendererParams} from "ag-grid-community";

/**
 *
 * @class DiversionWorkRenderer
 *
 * @brief cell rendering for the diversions workblock
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      July 2020
 *
 */
export class DiversionWorkRenderer implements ICellRenderer {

  /** agGrid DOM element for display */
  public gui: HTMLElement;

  /** the value being rendered */
  public value: WorkBlock;

  /** first time creation of the rendered cell. */
  public init(params: ICellRendererParams): void {

    this.gui           = document.createElement('div');
    this.gui.innerHTML = `<span style="color: grey;">Name...</span>`;

    /* render! */

    this.refresh(params);
  }

  /** return the currently rendered DOM */
  public getGui(): HTMLElement {

    return this.gui;
  }

  /** update the rendered DOM */
  public refresh(params: ICellRendererParams): boolean {

    this.value = params?.value;

    if (!this.value) {

      this.gui.innerHTML = `<span style="color: grey;">#? -</span>`;
      return ;
    }

    this.gui.innerHTML = `<span style="color: grey;">#${this.value._id} ${this.value._name}</span>`;

    return true;
  }

  /** destructor for rendered DOM */
  public destroy() {

  }

}
